<template>
  <div>
    <div class="marginTop20 marginBottom20">
      <a v-for="(item,index) in addSubsribe.lablename" :key="index" @click="clklablename(item,index)" :class="{gl_pad_btn_active:gl_pad_btn_active==index}" class="gl_pad_square_btn marginRight5">{{item}}</a>

    </div>
    <div class="gl_title_bar">
      <div class="gl_tb_left">

        <span :class="{tagTitleActive:tagIndex=='inTagInfor'}" @click="tagContent('inTagInfor',1)" class="tagTitleLine" style="font-size: 18px;font-weight: normal;">资讯</span>
        <span :class="{tagTitleActive:tagIndex=='inTagCourse'}" @click="tagContent('inTagCourse',2)" class="tagTitleLine" style="font-size: 18px;font-weight: normal;">课程</span>
        <span :class="{tagTitleActive:tagIndex=='inTagLite'}" @click="tagContent('inTagLite',3)" class="tagTitleLine" style="font-size: 18px;font-weight: normal;">文献</span>
      </div>
    </div>
    <component :datapageList="dataList" :is="tagIndex"></component>
  </div>
</template>

<script>
import inTagInfor from "./inTagInfor"
import inTagCourse from "./inTagCourse"
import inTagLite from "./inTagLite"
import lodash from "lodash"
export default {
  name: "tagSubscribeContent",
  data() {
    return {
      tagtype: 1,
      addSubsribe: {
        frequency: "2", //频率
        lablename: [],
        pushemail: "",
        id: 0,
        isFirstSubscript: 0,
        userid: Number(this.AuthorId), //用户ID
        username: this.userName,
        status: 0
      },
      dataList: [],
      gl_pad_btn_active: 0,
      tagIndex: "inTagInfor",
      tagIndex1: "",
      newsList: [],//订阅内容资讯列表
      courseList: [],//订阅内容课程列表
      articlelist: [],//订阅内容文献列表
      lablename: "",//标签选择
    }
  },
  components: {
    inTagInfor,
    inTagCourse,
    inTagLite
  },
  methods: {
    tagContent(index, type) {
      this.tagIndex = index
      this.tagtype = type
      this.GetSubscriptionInfoList(type, -1);
    },
    //标签的点击事件
    clklablename(tag, index) {
      this.lablename = tag;
      this.gl_pad_btn_active = index;
      this.GetSubscriptionInfoList(this.tagtype, -1);
    },
    //查询订阅信息
    GetSubscriptionInfoList(type, stat) {
      let _this = this
      _this.dataList = []
      _this.newsList = [],//订阅内容资讯列表
        _this.courseList = [],//订阅内容课程列表
        _this.articlelist = [],//订阅内容文献列表
        _this.httphelper.post('/api/SubscriptionApi/GetSubscriptionInfoList', {
          "id": 0,
          "lablename": "",
          "frequency": 0,
          "pushemail": "",
          "isFirstSubscript": 0,
          "userid": Number(this.AuthorId), //用户ID
          "username": "",
          "status": 0
        }).then(res => {
          if (res.data.code == 200) {
            if (res.data.data != null) {
              let data = res.data.data
              _this.addSubsribe = data;
              _this.addSubsribe.lablename = data.lablename.split(',');
              _this.addSubsribe.frequency = data.frequency.toString();
              if (stat != -1) {
                _this.lablename = _this.addSubsribe.lablename[0];
              }
              if (data.subscriptionInfoResult != null) {
                data.subscriptionInfoResult.forEach((item) => {
                  if (item.typename == "资讯") {
                    _this.newsList.push(item)
                  }
                  if (item.typename == "课程") {
                     
                    item.labelname = item.labelname.substring(0, item.labelname.length - 1)
                    _this.courseList.push(item)
                  }
                  if (item.typename == "文献") {
                    _this.articlelist.push(item)
                  }
                })
                if (type == 1) {
                  _this.dataList = _this.newsList.filter(item => item.label == _this.lablename)
                } else if (type == 2) {
                  _this.courseList = _this.courseList.filter(item => item.label == _this.lablename)
                  _this.dataList = lodash.chunk(_this.courseList, 3);
                } else if (type == 3) {
                  _this.dataList = _this.articlelist.filter(item => item.label == _this.lablename)
                }
              }
            }
          }
        });
    },
  },
  created() {
    //获取用户信息
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id
      this.userName = JSON.parse(localStorage.getItem("ResData")).nickname;
    }
    //1.先根据用户id查询，是否第一次订阅
    this.GetSubscriptionInfoList(1, 0);
    //2.如果第一次订阅，则提交订阅信息
    //3.否则，直接显示订阅列表 
  }
}
</script>

<style scoped>
</style>
